import React from "react";
import { useNavigate } from "react-router-dom";
import CompanyForm from "../../components/company/CompanyForm";
import { premiumPaths } from "../../navigation";

/** Po utworzeniu firmy przechodzi do jej ustawień, skąd można nadać dostęp pracownikom. */
export default function AddCompanyPage({ options, token }) {
  const navigate = useNavigate();
  return (
    <CompanyForm
      options={options}
      token={token}
      onSaved={(company) =>
        navigate(premiumPaths.settings(company.id), {
          replace: true,
        })
      }
    />
  );
}
